import styles from "./Slider.module.css";
import { IconFull, IconEmpty} from "../Icons/Icons";
import { JSX, useState } from "react";
	
export default function Slider({slides} : { slides : string[][]} ) {
	
	let length: number = slides.length;
	let dots: JSX.Element[] = Array(length).fill(<IconEmpty />);
	let defaultDots: JSX.Element[] = Array(length).fill(<IconEmpty />);
    defaultDots[0] = <IconFull />;

	const [currentSlide, setCurrentSlide] = useState(0);
	const [currentDots, setCurrentDots] = useState(defaultDots);

	
	function goToNextSlide(direction: "left" | "right") {
		if (direction === "left") {
			const isFirstSlide = currentSlide === 0;
			const newIndex = isFirstSlide
				? slides.length - 1
				: currentSlide - 1;
			setCurrentSlide(newIndex);
			dots[newIndex] = <IconFull />;
			setCurrentDots(dots);
		} else {
			const isLastSlide = currentSlide === slides.length - 1;
			const newIndex = isLastSlide ? 0 : currentSlide + 1;
			setCurrentSlide(newIndex);
			dots[newIndex] = <IconFull />;
			setCurrentDots(dots);
		}
	}
	return (
		<>
			<div className={styles.wrapper}>
				<img
					src={slides[currentSlide][0]}
					alt={`Stock Dashboard Slide ${currentSlide + 1}`}
					className={styles.image}
				/>
				<div className={styles.buttonContainer}>
					<button
						className={styles.button}
						onClick={() => goToNextSlide("left")}
					>
						<p className={styles.buttonTextLeft}>{"〈"}</p>
					</button>
					<button
						className={styles.button}
						onClick={() => goToNextSlide("right")}
					>
						<p className={styles.buttonTextRight}>{"〉"}</p>
					</button>
				</div>
			</div>
			<div className={styles.dotContainer}>
				{currentDots}
			</div>
			<h1 className={styles.caption}>{slides[currentSlide][1]}</h1>
		
		</>
	);
}
